import { getRegistrationEndpoint } from "../../../utils/getEndpoints";
import { bindSubmitButton } from "../../collectPasswordHelper";
import {
  emailFieldValidation,
  handleResetPasswordErrors
} from "../../main";

let S = process.env.NODE_ENV.toLowerCase() !== 'test' ? com.ts.mobile.sdk : { FormInput: {} };

export default class CustomFormSession {
  constructor(formId, payload, helper) {
    this.helper = helper;
    this.payload = payload;
    this.formId = formId;
  }

  startSession(clientContext, actionContext) {
    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.uiContext = actionContext.getUiContext();
  }

  promiseFormInput() {
    switch (this.formId) {
      case "email_and_mobile_details":
        return this.promiseEmailAndMobileForm();
      case "user_details":
        return this.promiseUserDetailsForm();
      case "collect_password":
        return this.promiseCollectPswdForm();
      case "set_challenge_questions_and_answers":
        return this.promiseSetChallengeQAForm();
      case "collect_username":
        return this.promiseCollectUsernameForm();
      case "registration_link_expired":
        return this.promiseRegistrationLinkExpired();
      case "validate_challenge_qa":
        return this.promiseValidateChallengeQAForm();
      case "remember_device":
        return this.promiseRememberMeForm();
      default:
        throw new Error("No Form implemeneted for formId: " + this.formId);
    }
  }

  promiseRegistrationLinkExpired() {
    const formEle = document.createElement("form")
    formEle.id = "registration_link_expired"
    return new Promise((resolve, reject) => {
      document.querySelector("#create-password-container").appendChild(formEle)
      console.log('Registration link expired')
      window.location.replace(`${getRegistrationEndpoint()}partner-error?email=${this.payload.email}`)
      let form_input = { actions: {} };
      resolve(S.FormInput.createFormInputSubmissionRequest(form_input));
    });
  }

  promiseEmailAndMobileForm() {
    let formDiv = document.createElement("div");
    let formHeader = document.createElement("h3");
    formHeader.classList.add("mt-4");
    formHeader.textContent = "Please enter Email and Mobile";

    let formMsg = document.createElement("h4");
    formMsg.setAttribute("font-color", "red");
    formMsg.classList.add("mt-4");

    if (this.payload.msg) {
      formMsg.textContent = this.payload.msg;
    }

    let email_address_input = this.helper.creatFormInputAndLabel([
      {
        label: "Email Address",
        type: "email",
        id: "email",
      },
    ]);

    let mobile_input = this.helper.creatFormInputAndLabel([
      {
        label: "Mobile",
        type: "tel",
        id: "mobile",
      },
    ]);

    formDiv.appendChild(formHeader);
    formDiv.appendChild(formMsg);
    formDiv.appendChild(email_address_input);
    formDiv.appendChild(mobile_input);

    return new Promise((resolve, reject) => {
      let submitButton = document.createElement("button");
      submitButton.classList.add("btn");
      submitButton.classList.add("btn-primary");
      submitButton.textContent = "Submit";
      submitButton.onclick = () => {
        let form_input = { actions: {} };

        form_input["actions"]["email"] = document.getElementById("email").value;
        form_input["actions"]["mobile"] =
          document.getElementById("mobile").value;

        formDiv.innerHTML = "";
        resolve(S.FormInput.createFormInputSubmissionRequest(form_input));
      };

      let cancelButton = document.createElement("button");
      cancelButton.classList.add("btn");
      cancelButton.classList.add("btn-warning");
      cancelButton.textContent = "Cancel";
      cancelButton.onclick = () => {
        formDiv.innerHTML = "";
        resolve(S.FormInput.createFormCancellationRequest());
      };
      let buttonGroup = this.helper.createButtonGroup([
        submitButton,
        cancelButton,
      ]);

      formDiv.appendChild(buttonGroup);
      this.helper.presentUI(formDiv, this.clientContext);
    });
  }

  promiseUserDetailsForm() {
    let formDiv = document.createElement("div");
    let formHeader = document.createElement("h3");
    formHeader.classList.add("mt-4");
    formHeader.textContent = "Please enter user details";

    let formMsg = document.createElement("h4");
    formMsg.setAttribute("font-color", "red");
    formMsg.classList.add("mt-4");

    if (this.payload.msg) {
      formMsg.textContent = this.payload.msg;
    }

    let first_name_input = this.helper.creatFormInputAndLabel([
      {
        label: "First Name",
        type: "text",
        id: "first_name",
      },
    ]);

    let last_name_input = this.helper.creatFormInputAndLabel([
      {
        label: "Last Name",
        type: "text",
        id: "last_name",
      },
    ]);

    let username_input = this.helper.creatFormInputAndLabel([
      {
        label: "Username",
        type: "text",
        id: "form_username",
      },
    ]);

    formDiv.appendChild(formHeader);
    formDiv.appendChild(formMsg);
    formDiv.appendChild(first_name_input);
    formDiv.appendChild(last_name_input);
    formDiv.appendChild(username_input);

    return new Promise((resolve, reject) => {
      let submitButton = document.createElement("button");
      submitButton.classList.add("btn");
      submitButton.classList.add("btn-primary");
      submitButton.textContent = "Submit";
      submitButton.onclick = () => {
        let form_input = { actions: {} };
        form_input["actions"]["first_name"] =
          document.getElementById("first_name").value;
        form_input["actions"]["last_name"] =
          document.getElementById("last_name").value;
        form_input["actions"]["username"] =
          document.getElementById("form_username").value;

        formDiv.innerHTML = "";
        resolve(S.FormInput.createFormInputSubmissionRequest(form_input));
      };

      let cancelButton = document.createElement("button");
      cancelButton.classList.add("btn");
      cancelButton.classList.add("btn-warning");
      cancelButton.textContent = "Cancel";
      cancelButton.onclick = () => {
        formDiv.innerHTML = "";
        resolve(S.FormInput.createFormCancellationRequest());
      };
      let buttonGroup = this.helper.createButtonGroup([
        submitButton,
        cancelButton,
      ]);

      formDiv.appendChild(buttonGroup);
      this.helper.presentUI(formDiv, this.clientContext);
    });
  }

  promiseCollectPswdForm() {
    const isCreatePassword = window.location.href.includes('partner-login')

    if (!isCreatePassword) {
      document.querySelector('#otp-input').classList.add("hidden")
      document.querySelector('#reset-password').classList.remove("hidden")
    }

    if (this.payload.msg) {
      const errors = this.payload.errors;
      handleResetPasswordErrors(errors);
    }

    return new Promise((resolve, reject) => {
      bindSubmitButton((form_input) => {
        resolve(S.FormInput.createFormInputSubmissionRequest(form_input));
      });
    });
  }

  promiseSetChallengeQAForm() {
    let formDiv = document.createElement("div");
    let formHeader = document.createElement("h3");
    formHeader.classList.add("mt-4");
    formHeader.textContent = "Set Challenge Questions and Answers";

    let formMsg = document.createElement("h4");
    formMsg.setAttribute("font-color", "red");
    formMsg.classList.add("mt-4");

    if (this.payload.msg) {
      formMsg.textContent = this.payload.msg;
    }

    let group1_label = document.createElement("label");
    group1_label.textContent = "Group 1 Questions";
    let break1 = document.createElement("br");
    let group1 = document.createElement("select");
    group1.setAttribute("id", "group1");
    let group4 = document.createElement("select");
    group4.setAttribute("id", "group4");

    let group2_label = document.createElement("label");
    group2_label.textContent = "Group 2 Questions";
    let break2 = document.createElement("br");
    let group2 = document.createElement("select");
    group2.setAttribute("id", "group2");
    let group5 = document.createElement("select");
    group5.setAttribute("id", "group5");

    let group3_label = document.createElement("label");
    group3_label.textContent = "Group 3 Questions";
    let break3 = document.createElement("br");
    let group3 = document.createElement("select");
    group3.setAttribute("id", "group3");
    let group6 = document.createElement("select");
    group6.setAttribute("id", "group6");

    let group14_decider_counter = 2; // starting at 2 to avoid having to write boundary conditions
    let group25_decider_counter = 2;
    let group36_decider_counter = 2;

    let challengeQuestions = null;
    if (this.formId == "set_challenge_questions_and_answers") {
      challengeQuestions = this.payload.challengeQuestions;
    } else {
      challengeQuestions = this.payload.challengeQuestionAnswers;
    }

    challengeQuestions.forEach((element) => {
      let option = document.createElement("option");
      option.value = element.id;
      option.text = element.question;
      option.setAttribute("id", element.id);

      switch (element.group) {
        case 1:
          if (group14_decider_counter % 2 == 0) {
            group1.appendChild(option);
          } else {
            group4.appendChild(option);
          }
          group14_decider_counter++;
          break;
        case 2:
          if (group25_decider_counter % 2 == 0) {
            group2.appendChild(option);
          } else {
            group5.appendChild(option);
          }

          group25_decider_counter++;
          break;
        default:
          if (group36_decider_counter % 2 == 0) {
            group3.appendChild(option);
          } else {
            group6.appendChild(option);
          }

          group36_decider_counter++;
          break;
      }
    });
    let group1_answer = this.helper.creatFormInputAndLabel([
      {
        label: "Answer",
        type: "text",
        id: "group1_answer",
      },
    ]);

    let group2_answer = this.helper.creatFormInputAndLabel([
      {
        label: "Answer",
        type: "text",
        id: "group2_answer",
      },
    ]);

    let group3_answer = this.helper.creatFormInputAndLabel([
      {
        label: "Answer",
        type: "text",
        id: "group3_answer",
      },
    ]);

    let group4_answer = this.helper.creatFormInputAndLabel([
      {
        label: "Answer",
        type: "text",
        id: "group4_answer",
      },
    ]);

    let group5_answer = this.helper.creatFormInputAndLabel([
      {
        label: "Answer",
        type: "text",
        id: "group5_answer",
      },
    ]);

    let group6_answer = this.helper.creatFormInputAndLabel([
      {
        label: "Answer",
        type: "text",
        id: "group6_answer",
      },
    ]);

    formDiv.appendChild(formHeader);
    formDiv.appendChild(formMsg);
    formDiv.appendChild(group1_label);
    formDiv.appendChild(break1);
    formDiv.appendChild(group1);
    formDiv.appendChild(group1_answer);
    formDiv.appendChild(group4);
    formDiv.appendChild(group4_answer);
    formDiv.appendChild(group2_label);
    formDiv.appendChild(break2);
    formDiv.appendChild(group2);
    formDiv.appendChild(group2_answer);
    formDiv.appendChild(group5);
    formDiv.appendChild(group5_answer);
    formDiv.appendChild(group3_label);
    formDiv.appendChild(break3);
    formDiv.appendChild(group3);
    formDiv.appendChild(group3_answer);
    formDiv.appendChild(group6);
    formDiv.appendChild(group6_answer);

    return new Promise((resolve, reject) => {
      let submitButton = document.createElement("button");
      submitButton.classList.add("btn");
      submitButton.classList.add("btn-primary");
      submitButton.textContent = "Submit";
      submitButton.onclick = () => {
        let form_input = { actions: [] };

        form_input.actions.push({
          questionId: document.getElementById("group1").value,
          question:
            document.getElementById("group1").options[
              document.getElementById("group1").options.selectedIndex
            ].text,
          answer: document.getElementById("group1_answer").value,
        });

        form_input.actions.push({
          questionId: document.getElementById("group2").value,
          question:
            document.getElementById("group2").options[
              document.getElementById("group2").options.selectedIndex
            ].text,
          answer: document.getElementById("group2_answer").value,
        });

        form_input.actions.push({
          questionId: document.getElementById("group3").value,
          question:
            document.getElementById("group3").options[
              document.getElementById("group3").options.selectedIndex
            ].text,
          answer: document.getElementById("group3_answer").value,
        });

        form_input.actions.push({
          questionId: document.getElementById("group4").value,
          question:
            document.getElementById("group4").options[
              document.getElementById("group4").options.selectedIndex
            ].text,
          answer: document.getElementById("group4_answer").value,
        });

        form_input.actions.push({
          questionId: document.getElementById("group5").value,
          question:
            document.getElementById("group5").options[
              document.getElementById("group5").options.selectedIndex
            ].text,
          answer: document.getElementById("group5_answer").value,
        });

        form_input.actions.push({
          questionId: document.getElementById("group6").value,
          question:
            document.getElementById("group6").options[
              document.getElementById("group6").options.selectedIndex
            ].text,
          answer: document.getElementById("group6_answer").value,
        });

        formDiv.innerHTML = "";
        resolve(S.FormInput.createFormInputSubmissionRequest(form_input));
      };

      let cancelButton = document.createElement("button");
      cancelButton.classList.add("btn");
      cancelButton.classList.add("btn-warning");
      cancelButton.textContent = "Cancel";
      cancelButton.onclick = () => {
        formDiv.innerHTML = "";
        resolve(S.FormInput.createFormCancellationRequest());
      };
      let buttonGroup = this.helper.createButtonGroup([
        submitButton,
        cancelButton,
      ]);

      formDiv.appendChild(buttonGroup);
      this.helper.presentUI(formDiv, this.clientContext);
    });
  }

  promiseCollectUsernameForm() {
    /* forgot password 
    */
    const emailAddress = this.clientContext.emailAddress
    return new Promise((resolve, reject) => {
      // validates emailAddress
      const validInput = emailFieldValidation(emailAddress)


      if (validInput) {
        let form_input = { actions: {} };
        form_input["actions"]["username"] = emailAddress;


        resolve(S.FormInput.createFormInputSubmissionRequest(form_input));
      }

    });
  }

  promiseValidateChallengeQAForm() {
    let formDiv = document.createElement("div");
    let formHeader = document.createElement("h3");
    formHeader.classList.add("mt-4");
    formHeader.textContent = "Please answer Challenge Q & A";

    let formMsg = document.createElement("h4");
    formMsg.setAttribute("font-color", "red");
    formMsg.classList.add("mt-4");

    if (this.payload.msg) {
      formMsg.textContent = this.payload.msg;
    }

    let question1 = document.createElement("h5");
    question1.setAttribute("id", "question1");
    question1.textContent =
      this.payload.challengeQuestionAnswers[0]["question"];
    question1.setAttribute(
      "question_id",
      this.payload.challengeQuestionAnswers[0]["questionId"]
    );
    let question1_answer = this.helper.creatFormInputAndLabel([
      {
        label: "Answer",
        type: "text",
        id: "question1_answer",
      },
    ]);

    let question2 = document.createElement("h5");
    question2.setAttribute("id", "question2");
    question2.textContent =
      this.payload.challengeQuestionAnswers[1]["question"];
    question2.setAttribute(
      "question_id",
      this.payload.challengeQuestionAnswers[1]["questionId"]
    );
    let question2_answer = this.helper.creatFormInputAndLabel([
      {
        label: "Answer",
        type: "text",
        id: "question2_answer",
      },
    ]);

    let question3 = document.createElement("h5");
    question3.setAttribute("id", "question3");
    question3.textContent =
      this.payload.challengeQuestionAnswers[2]["question"];
    question3.setAttribute(
      "question_id",
      this.payload.challengeQuestionAnswers[1]["questionId"]
    );
    let question3_answer = this.helper.creatFormInputAndLabel([
      {
        label: "Answer",
        type: "text",
        id: "question3_answer",
      },
    ]);

    formDiv.appendChild(formHeader);
    formDiv.appendChild(formMsg);
    formDiv.appendChild(question1);
    formDiv.appendChild(question1_answer);
    formDiv.appendChild(question2);
    formDiv.appendChild(question2_answer);
    formDiv.appendChild(question3);
    formDiv.appendChild(question3_answer);

    return new Promise((resolve, reject) => {
      let submitButton = document.createElement("button");
      submitButton.classList.add("btn");
      submitButton.classList.add("btn-primary");
      submitButton.textContent = "Submit";
      submitButton.onclick = () => {
        let form_input = { actions: [] };

        form_input.actions.push({
          questionId: document
            .getElementById("question1")
            .getAttribute("question_id"),
          question: document.getElementById("question1").textContent,
          answer: document.getElementById("question1_answer").value,
        });

        form_input.actions.push({
          questionId: document
            .getElementById("question2")
            .getAttribute("question_id"),
          question: document.getElementById("question2").textContent,
          answer: document.getElementById("question2_answer").value,
        });

        form_input.actions.push({
          questionId: document
            .getElementById("question3")
            .getAttribute("question_id"),
          question: document.getElementById("question3").textContent,
          answer: document.getElementById("question3_answer").value,
        });

        formDiv.innerHTML = "";
        resolve(S.FormInput.createFormInputSubmissionRequest(form_input));
      };

      let cancelButton = document.createElement("button");
      cancelButton.classList.add("btn");
      cancelButton.classList.add("btn-warning");
      cancelButton.textContent = "Cancel";
      cancelButton.onclick = () => {
        formDiv.innerHTML = "";
        resolve(S.FormInput.createFormCancellationRequest());
      };
      let buttonGroup = this.helper.createButtonGroup([
        submitButton,
        cancelButton,
      ]);

      formDiv.appendChild(buttonGroup);
      this.helper.presentUI(formDiv, this.clientContext);
    });
  }

  promiseRememberMeForm() {
    return Promise.resolve(
      S.FormInput.createFormInputSubmissionRequest(
        "rememberme" in this.clientContext
          ? { remember_me: this.clientContext["rememberme"] }
          : { remember_me: false }
      )
    );
  }

  onContinue(payload) {
    this.payload = payload;
  }

  onError(payload) {
    this.payload = payload;
  }

  endSession() { return; }
}
